export function httpErrorMessage(error, fallback = "Request failed") {
  const msg =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback;
  return typeof msg === "string" ? msg : fallback;
}
